import { render, staticRenderFns } from "./PostDialog.vue?vue&type=template&id=71b9d855"
import script from "./PostDialog.vue?vue&type=script&lang=js"
export * from "./PostDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports